// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonRoles = {
  admin: "Administrator",
  question_editor: "Question Editor",
  exam_manager: "Exam Manager",
  reviewer: "Reviewer",
  proctor: "Proctor",
  candidate: "Candidate",
  platform_user: "Platform User",
} as const;
